import { render } from "./DistributorLink.vue?vue&type=template&id=0499d096"
import script from "./DistributorLink.vue?vue&type=script&lang=js"
export * from "./DistributorLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__